import Component from "./component";
import Connector from "./connector";
import actions from "./actions";
import getters from "./getters";

const container = Connector("WorkflowList", Component);

export { actions, container, getters };
